// Retailers section tab functionality

(function () {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRetailersTabs);
  } else {
    initRetailersTabs();
  }

  function initRetailersTabs() {
    const retailersSection = document.querySelector('.retailers-tabs');
    if (!retailersSection) return;

    const triggers = retailersSection.querySelectorAll('.tab-trigger');
    const selectElement = retailersSection.querySelector('#RetailersLocationSelect');

    function updateActiveTab(triggerElement, targetId) {
      triggers.forEach((tab) => {
        tab.classList.remove('link-styled--active');
      });

      if (triggerElement) {
        triggerElement.classList.add('link-styled--active');
      }

      const allTabItems = retailersSection.querySelectorAll('.tabs__item');
      allTabItems.forEach((item) => {
        item.classList.remove('tabs__item--active');
        item.classList.add('tabs__item--inactive');
      });

      const targetTab = retailersSection.querySelector(`#${targetId}`);
      if (targetTab) {
        targetTab.classList.remove('tabs__item--inactive');
        targetTab.classList.add('tabs__item--active');
      }

      if (selectElement) {
        selectElement.value = targetId;
      }

    }

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('data-trigger');
        if (targetId) {
          updateActiveTab(this, targetId);
        }
      });
    });

    if (selectElement) {
      selectElement.addEventListener('change', function (e) {
        const targetId = e.target.value;
        if (targetId) {
          const correspondingTrigger = Array.from(triggers).find(
            (trigger) => trigger.getAttribute('data-trigger') === targetId
          );
          updateActiveTab(correspondingTrigger, targetId);
        }
      });
    }
  }
})();

